import { CakeIcon, CircleInfoIcon, PinIcon } from "@xola/icons";
import { DateFormat, formatDate } from "common";
import dayjs, { Dayjs } from "dayjs";
import { isEmpty } from "lodash";
import React from "react";
import { Traveler } from "types";
import { NoTranslate } from "../../Common/NoTranslate";
import { getISOFormattedDateString } from "@/components/Questionnaire/DateOfBirthField";

export const ContactData = ({ contact }: { contact: Traveler }) => {
    const hasHeight = !isEmpty(contact.data?.Height?.trim());
    const hasWeight = !isEmpty(contact.data?.Weight?.trim());
    let dateOfBirth = contact.data?.["Date of birth"]?.trim();
    if (dateOfBirth) {
        dateOfBirth = getISOFormattedDateString(dateOfBirth, true);
    }
    return (
        <span className="flex items-center space-x-3 text-gray-darker">
            {(hasHeight || hasWeight) && (
                <NoTranslate data-testid="contact-data-weight-and-height">
                    <CircleInfoIcon className="mr-1" />
                    {hasWeight && <span>{contact.data?.Weight} lbs.</span>}
                    {hasHeight && <span>{contact.data?.Height} ft.</span>}
                </NoTranslate>
            )}
            {dateOfBirth && (
                <NoTranslate data-testid="contact-data-date-of-birth">
                    <CakeIcon className="mr-1" />
                    {formatDate(dateOfBirth, DateFormat.DATE_LONG)}
                    {" ("}
                    {toYears(dateOfBirth)}
                    yrs)
                </NoTranslate>
            )}
            {contact.data?.Address && (
                <NoTranslate data-testid="contact-data-address">
                    <PinIcon className="mr-1" />
                    {contact.data.Address}
                </NoTranslate>
            )}
        </span>
    );
};

/**
 * Convert the given date to current date in years.
 */
const toYears = (date: string | Date | Dayjs) => {
    return dayjs(dayjs()).diff(date, "year");
};
